import React, { useState, useContext, useEffect } from "react";
import { Card, CardBody, Col, Container, Row, Button, Alert } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { ServiceContext } from "context/ServiceContextProvider";
import { useGetUserPermissionsByRoleIdActionMutation } from "slices/employee/employeeSlice";

import logoLight from "../../assets/images/puretech-logo-md.png";

interface LocationState {
  roles: string[];
  roleIds: number[];
  login: any;
}

const SelectRole = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error(
      "ServiceContext must be used within a ServiceContextProvider",
    );
  }

  const { setselectedRoleId, setSelectedRoleName, setPermissionsList } =
    context;

  const { roles, roleIds, login } = (location.state as LocationState) || {};

  const [selectedRole, setSelectedRole] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  const [getUserPermissionsByRoleIdAction] =
    useGetUserPermissionsByRoleIdActionMutation();

  // Fetch selected role from sessionStorage when the component mounts
  useEffect(() => {
    // const storedRole = sessionStorage.getItem("selectedRole");
    const storedRole = localStorage.getItem("selectedRole");

    if (storedRole) {
      const { role_id, role_name } = JSON.parse(storedRole);
      setselectedRoleId(role_id);
      setSelectedRoleName(role_name);
      setSelectedRole(role_id);
    }
  }, [setselectedRoleId, setSelectedRoleName]);

  const handleRoleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRole(event.target.value);
  };

  const handleSubmit = async () => {
    if (!selectedRole) {
      setError("Please select a role to continue.");
      return;
    }

    setError(null);
    const selectedIndex = roleIds.indexOf(parseInt(selectedRole));
    if (selectedIndex === -1) {
      setError("Role not found. Please try again.");
      return;
    }

    const selectedRoleName = roles[selectedIndex];

    localStorage.setItem(
      "selectedRole",
      JSON.stringify({ role_id: selectedRole, role_name: selectedRoleName }),
    );

    setselectedRoleId(selectedRole);
    setSelectedRoleName(selectedRoleName);

    // Dispatch the role to Redux
    sessionStorage.setItem("authUser", JSON.stringify(login));
    localStorage.setItem("authUser", JSON.stringify(login));

    const data: any = await getUserPermissionsByRoleIdAction(selectedRole);

    if (data?.data && data.data?.user_permissions) {
      // Set permissions in the context
      setPermissionsList(data.data?.user_permissions);
    }
    navigate("/dashboard");
  };

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <img src={logoLight} alt="" height="60" />
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Select Your Role</h5>
                      <p className="text-muted">
                        Please choose a role to continue.
                      </p>
                    </div>
                    {error && <Alert color="danger">{error}</Alert>}
                    <div className="p-2 mt-4">
                      <div className="form-group">
                        {roles && roles.length > 0 ? (
                          <select
                            className="form-control"
                            value={selectedRole}
                            onChange={handleRoleSelect}
                          >
                            <option value="" disabled>
                              Select a role
                            </option>
                            {roles.map((roleName: string, index: number) => (
                              <option
                                key={roleIds[index]}
                                value={roleIds[index]}
                              >
                                {roleName}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <p>No roles available. Please contact support.</p>
                        )}
                      </div>

                      <div className="mt-4">
                        <Button
                          color="success"
                          className="btn w-100"
                          onClick={handleSubmit}
                        >
                          Continue
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default SelectRole;
